import { useState } from "react";
import { QuestionnaireSelectableItem } from "../../legalEntityAuditTab/LegalEntityAudit.types";
import { LegalEntityClassificationModel } from "./LegalEntityClassificationDialog.types";
import { useValidator } from "../../../common/hooks/validation";
import { useTranslation } from "../../../localization/useTranslation";
import { post } from "../../../common/api/apiShared";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { ILegalEntityClassificationDialog } from "./LegalEntityClassificationDialog";
import { SelectableItem } from "../../../processingActivity/ProcessingActivity.types";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export default function useLegalEntityClassificationDialogHooks(props: ILegalEntityClassificationDialog) {
    const snackbar = useDotLegalSnackbar();
    const { translateString } = useTranslation();
    const [saveModel, setSaveModel] = useState<LegalEntityClassificationModel>(new LegalEntityClassificationModel(props.processingActivityId));

    const validation = useValidator<LegalEntityClassificationModel>(
        (validators) => ({
            questionnaireIds: validators.validateNotEmpty((item) => item.questionnaireIds, translateString("audit")),
        }),
        []
    );

    function onSaveClick() {
        if (validation.anyHasErrors) {
            validation.setShowErrors(true);
            return;
        }

        addTemplates();
    }

    const saveMutation = useDotLegalMutation(saveAPI, {
        onSuccess: (response: any) => {
            snackbar.show(translateString("classificationTemplatesAreCreated"));

            if (response?.value()?.id) {
                props.onCreated(response.value().id);
            } else {
                props.onCreated();
            }
        },
    });

    const addTemplates = async () => {
        await saveMutation.mutateAsync();
    };

    const onQuestionnairesChanged = (questionnaires: Array<QuestionnaireSelectableItem>) => {
        var temp = { ...saveModel! };
        temp.questionnaireIds = questionnaires.map((x) => x.id);

        setSaveModel(temp);
    };

    const onQuestionnaireChanged = (questionnaire?: QuestionnaireSelectableItem) => {
        var temp = { ...saveModel! };
        if (questionnaire) {
            temp.questionnaireIds = [questionnaire.id];
        } else {
            temp.questionnaireIds = [];
        }

        setSaveModel(temp);
    };

    const onSystemChange = (item: SelectableItem | undefined) => {
        var temp = { ...saveModel! };
        temp.systemId = item?.id;

        setSaveModel(temp);
    };

    const onProcessingActivityChange = (item: SelectableItem | undefined) => {
        var temp = { ...saveModel! };
        temp.processingActivityId = item?.id;

        setSaveModel(temp);
    };

    return {
        onQuestionnaireChanged,
        onQuestionnairesChanged,
        saveModel,
        validation,
        onSaveClick,
        onSystemChange,
        onProcessingActivityChange,
        isSaving: saveMutation.isLoading,
    };

    function saveAPI() {
        if (props.processingActivityId) {
            return post(`/LegalEntityClassification/${props.legalEntityId}/single`, saveModel);
        }

        return post(`/LegalEntityClassification/${props.legalEntityId}`, saveModel);
    }
}
